import NotificationSound from "./notification.mp3"

const sound = new Audio(NotificationSound)

export const notify = () => {
  sound.play().catch(() => {}) // silence the error

  if ("vibrate" in navigator) navigator.vibrate([80])
}
